import * as z from "zod/v4";

export const singleOrderAuth = {
  name: "singleOrderAuth" as const,
  input: z.object({
    emailOrZip: z.string(),
    orderIdTrackingNumber: z.string(),
  }),
  output: z.object({
    customerAuthToken: z.string(),
    customer: z
      .object({ name: z.string(), email: z.string(), customerId: z.string() })
      .nullish(),
    orderId: z.string(),
  }),
};
